export enum ECallStatus {
  Created = 'created',
  Started = 'started',
  Answered = 'answered',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Finished = 'finished',
}
